import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import WordList from "./WordList";

function Goal(props) {
  return (
    <div
      ref={props.goal}
      style={{
        borderRadius: "25px",
        minHeight: "200px",
        margin: "2px",
        paddingBottom: "30px",
        border: props.isOver ? "2px solid #FFC107" : props.errorCheckBorder,
      }}
    >
      <Col>
        <Row>
          <h1>
            <u>{props.goalArray.name}</u>
          </h1>
        </Row>
        <Row>
          <Col>
            {props.wordGoalArray.map((word) => (
              <WordList
                key={word.id}
                id={word.id}
                name={word.name}
                group={word.group}
                dragType={props.dragType}
                size="small"
                width={"400px"}
                height={'75px'}
                margin={"5px"}
              />
            ))}
          </Col>
        </Row>
      </Col>
    </div>
  );
}

export default Goal;
